import React from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../../../components/opal/OpalHeading'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import LinkCard from '../common/LinkCard'
import LinkCardDots from '../common/LinkCardDots'
import ScheduleMenu, { useScheduleMenu } from '../common/menu/ScheduleMenu'

function formatIntent (intent) {
  switch (intent) {
    case 'data_inquiry':
      return 'Data Inquiry'
    case 'data_inquiry_with_visuals':
      return 'Data Inquiry with Visualizations'
    case 'general_assistance':
      return 'General Assistance'
    case 'digest_scheduled_prompts':
      return 'Digest'
    default:
      return ''
  }
}

function formatSchedule (schedule) {
  const result = ['Runs']
  switch (schedule.interval) {
    case 'day':
      result.push('daily')
      break
    case 'week':
      result.push('weekly')
      break
    case 'month':
      result.push('monthly')
      break
    default:
      return ''
  }
  result.push('at the')
  result.push(schedule.bound)
  result.push('of the')
  result.push(schedule.interval)

  return result.join(' ')
}

function ScheduleListItem ({ scheduledPrompt, onEdit, onDelete }) {
  const scheduleMenu = useScheduleMenu(onEdit, onDelete)

  return (
    <LinkCard to={`/denali-ai/schedules/${scheduledPrompt.scheduleId}`}>
      <FlexRow>
        <FlexColumn className='gap-sm flex-1'>
          <FlexRow>
            <OpalHeading className='font-size-md'>{scheduledPrompt.name}</OpalHeading>
          </FlexRow>
          <FlexRow>
            <span className='font-sans font-size-xs'>{formatIntent(scheduledPrompt.configuration.intent)}</span>
          </FlexRow>
          <FlexRow>
            <span className='font-sans font-size-xs'>{formatSchedule(scheduledPrompt.configuration.schedule)}</span>
          </FlexRow>
        </FlexColumn>
        <FlexColumn>
          <LinkCardDots onClick={scheduleMenu.handleMenuOpen} />
        </FlexColumn>
      </FlexRow>
      <ScheduleMenu
        subject={scheduledPrompt}
        menuAnchor={scheduleMenu.menuAnchor}
        onClose={scheduleMenu.handleMenuClose}
        onEdit={scheduleMenu.handleEdit}
        onDelete={scheduleMenu.handleDelete}
      />
    </LinkCard>
  )
}

ScheduleListItem.propTypes = {
  scheduledPrompt: PropTypes.shape({
    scheduleId: PropTypes.string,
    name: PropTypes.string,
    configuration: PropTypes.shape({
      intent: PropTypes.string,
      schedule: PropTypes.shape({
        interval: PropTypes.string,
        bound: PropTypes.string
      })
    })
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
}

export default ScheduleListItem
